const headerSearchToggle = document.querySelector('#header-search-toggle');
const headerSearchOverlay = document.querySelector('.header-search__overlay');

if (headerSearchToggle) {
  headerSearchToggle.addEventListener('click', () => {
    const body = document.querySelector('body');

    if (body.classList.contains('desktop-search-open')) {
      body.classList.remove('desktop-search-open');
    } else {
      body.classList.add('desktop-search-open');
      document
        .querySelector('#header-search-container .lavendla-search__input')
        .focus();
    }
  });
}

if (headerSearchOverlay) {
  document
    .querySelector('.header-search__overlay')
    .addEventListener('click', () => {
      document.querySelector('body').classList.remove('desktop-search-open');
    });
}
